import { render, staticRenderFns } from "./PerformanceReportingTable.vue?vue&type=template&id=166a0388&"
import script from "./PerformanceReportingTable.vue?vue&type=script&lang=js&"
export * from "./PerformanceReportingTable.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceReportingTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports